import dayjs from "dayjs";
import { useCallback, useMemo } from "react";
import { useSearchParams } from "react-router-dom";

export type ReportPeriod = { year: number; month: number };

const PERIOD = /^(\d{4})-(0[1-9]|1[0-2])$/;

export const periodKey = (p: ReportPeriod) => `${p.year}-${String(p.month).padStart(2, "0")}`;

export const parsePeriod = (value: string | null): ReportPeriod | null => {
  const m = value ? PERIOD.exec(value) : null;
  return m ? { year: Number(m[1]), month: Number(m[2]) } : null;
};

export const periodBounds = (p: ReportPeriod) => {
  const start = dayjs(`${periodKey(p)}-01`);
  return { from: start.format("YYYY-MM-DD"), to: start.endOf("month").format("YYYY-MM-DD") };
};

/** Хугацааг URL-д (`?period=YYYY-MM`) хадгална; байхгүй бол `dateFrom`-ийн сар, түүнгүй бол энэ сар. */
export function useReportPeriod(): [ReportPeriod, (p: ReportPeriod) => void] {
  const [params, setParams] = useSearchParams();
  const raw = params.get("period");
  const from = params.get("dateFrom");
  const period = useMemo(() => {
    const now = new Date();
    return (
      parsePeriod(raw) ??
      parsePeriod(from ? from.slice(0, 7) : null) ?? { year: now.getFullYear(), month: now.getMonth() + 1 }
    );
  }, [raw, from]);

  const setPeriod = useCallback(
    (p: ReportPeriod) => {
      const next = new URLSearchParams(params);
      next.set("period", periodKey(p));
      setParams(next, { replace: true });
    },
    [params, setParams],
  );

  return [period, setPeriod];
}
